import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where, orderBy } from "firebase/firestore";
import { db } from "../firebase";

export function useServiciosDestacados() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);

    // Nota: el orderBy("__name__") ayuda a estabilizar el orden
    // y suele ser el que te pide el índice compuesto cuando hay where + orderBy.
    const q = query(
      collection(db, "servicios_destacados"),
      where("activo", "==", true),
      orderBy("orden", "asc"),
      orderBy("__name__", "asc")
    );

    const unsub = onSnapshot(
      q,
      (snap) => {
        const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setItems(data);
        setLoading(false);
      },
      (err) => {
        console.error("[servicios_destacados] snapshot error:", err);
        setError(err?.message || "Error leyendo servicios destacados");
        setLoading(false);
      }
    );

    return () => unsub();
  }, []);

  return { items, loading, error };
}
